export class Server {
  constructor(version='05') {
    this.baseURL = 'https://ebl-experiment.de/rest/';
    this.newURL = this.baseURL + 'new05.php';
    this.saveURL = this.baseURL + 'save05.php';
    this.checkURL = this.baseURL + '_check.php?ver='+version;
  }

  getNewData() {
    return fetch(this.newURL).then(response => response.json());
  }
  getCheckData(userId) {
    return fetch(this.checkURL+'&user_id='+userId).then(response => response.json());
  }

  postData(userId, groupId, age, male, session, tag, data, valid=1) {
    const body = {
      user_id: userId,
      group_id: groupId,
      age,
      male,
      session,
      tag,
      data,
      valid,
    };
    return fetch(this.saveURL, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
  }
}